//# sourceMappingURL=angle.mjs.map
/// <reference types="./angle.d.mts" />
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

class Deg extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rad extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Grad extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Turn extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

/**
 * Represents an angle in [degrees](https://en.wikipedia.org/wiki/Degree_%28angle%29).
 * One full circle is `360deg`. Examples: `0deg`, `90deg`, `14.23deg`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/angle#deg)
 */
export function deg(value) {
  return new Deg(value);
}

/**
 * Represents an angle in [radians](https://en.wikipedia.org/wiki/Radian).
 * One full circle is 2π radians which approximates to `6.2832rad`. `1rad` is
 * 180/π degrees. Examples: `0rad`, 1`.0708rad`, `6.2832rad`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/angle#rad)
 */
export function rad(value) {
  return new Rad(value);
}

/**
 * Represents an angle in [gradians](https://en.wikipedia.org/wiki/Gradian).
 * One full circle is `400grad`. Examples: `0grad`, `100grad`, `38.8grad`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/angle#grad)
 */
export function grad(value) {
  return new Grad(value);
}

/**
 * Represents an angle in a number of turns. One full circle is `1turn`.
 * Examples: `0turn`, `0.25turn`, `1.2turn`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/angle#turn)
 */
export function turn(value) {
  return new Turn(value);
}

export function to_string(angle) {
  if (angle instanceof Deg) {
    let value = angle[0];
    return $float.to_string(value) + "deg";
  } else if (angle instanceof Rad) {
    let value = angle[0];
    return $float.to_string(value) + "rad";
  } else if (angle instanceof Grad) {
    let value = angle[0];
    return $float.to_string(value) + "grad";
  } else {
    let value = angle[0];
    return $float.to_string(value) + "turn";
  }
}
